/**
 * Summary Cards Component
 * Displays summary statistics with border-left accent styling
 */
import type { JSX } from 'react'

interface SummaryCard {
  label: string
  value: number
  accentColor: string
}

interface SummaryCardsProps {
  cards: SummaryCard[]
}

export default function SummaryCards({ cards }: SummaryCardsProps): JSX.Element {
  const gridCols = cards.length === 5 ? 'xl:grid-cols-5' : cards.length === 4 ? 'xl:grid-cols-4' : 'xl:grid-cols-3'

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 ${gridCols} gap-4`}>
      {cards.map((card, index) => (
        <div
          key={index}
          className="bg-white rounded-md border border-gray-100 border-l-4 p-5 shadow-sm"
          style={{ borderLeftColor: card.accentColor }}
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">{card.label}</p>
          <p className="text-2xl font-bold text-gray-900 mt-1.5 tracking-tight">{card.value}</p>
        </div>
      ))}
    </div>
  )
}
